<template>
  <div>
    <div class="container py-5">
      <!-- Placeholder -->
      <div v-if="!isPostLoaded">
        <div class="placeholder">
          <div class="post-cover"></div>

          <!-- Title -->
          <div class="row justify-content-center">
            <div class="col-12 col-md-10">
              <div class="page-title mt-5 mb-3"></div>
            </div>
            <div class="col-12 col-md-10">
              <div class="row">
                <div class="col">
                  <div class="paragraph" style="width: 35%;"></div>
                  <div class="paragraph" style="width: 45%;"></div>
                </div>
                <div class="col d-flex justify-content-end align-items-center">
                </div>
              </div>
            </div>
          </div>

          <!-- Content -->
          <div class="row justify-content-end mt-5">
            <div class="col-12 col-md-8">
              <div class="paragraph mb-3" style="width: 100%;"></div>
              <div class="paragraph mb-3" style="width: 100%;"></div>
              <div class="paragraph" style="width: 80%;"></div>
            </div>
            <div class="col-12 col-md-3"></div>
          </div>
        </div>
        <!-- /.placeholder -->
      </div>

      <div v-if="isPostLoaded">
        <!-- Title -->
        <div class="row justify-content-center">
          <div class="col-12 col-lg-10">
            <h1 class="page-title mb-3" v-html="post.title.rendered"></h1>
          </div>
          <div class="col d-flex justify-content-end align-items-center">
            <social-sharing :url="post.link"
                :title="post.title.rendered"
                :description="post.excerpt.rendered"
                inline-template
                network-tag="a"
            >
              <ul class="nav social-share">
                <li>
                  <network network="facebook">
                      <span class="icon facebook">Facebook</span>
                  </network>
                </li>
                <li>
                  <network network="twitter">
                      <span class="ml-4 icon twitter">Twitter</span>
                  </network>
                </li>
              </ul>
            </social-sharing>
          </div>
        </div>

        <div class="row mb-4" v-if="post.acf.author">
          <div class="col-12">
            <p class="m-0" v-html="post.acf.author"></p>
            <p class="m-0 text-black-50" v-html="dateFormat(post.date)"></p>
          </div>
        </div>

        <div class="row mb-5 justify-content-center">
          <div class="col-12 col-lg-10">
            <youtube class="video-container" :video-id="video_id" :player-vars="{  }" />
          </div>
        </div>

        <!-- <div class="row justify-content-center">
          <div class="col-12 col-lg-10">
            <div class="row my-3 my-lg-5">
              <div class="col-12 mb-3">
                <p class="my-0" v-if="post._embedded['wp:term']">
                  <a href="#" @click="getPlaylists" :class="{'d-inline-flex align-items-center text-dark ': true, 'disabled': isExpandedPlaylists}"><span class="icon small playlist mr-2"></span> <span v-html="post._embedded['wp:term'][0][0].name"></span></a>
                </p>
                <transition name="slide">
                  <div class="playlist-wrapper" v-if="isExpandedPlaylists && isPlaylistsLoaded">
                    <div class="playlist-container">
                      <div class="video-block" v-for="playlist in playlists" :key="playlist.id">
                        <router-link :to="{ name: playlist.type, params: { slug: playlist.slug } }" :title="playlist.title.rendered">
                          <div class="blog-article">
                            <div class="thumbnail">
                              <div class="thumbnail-media" v-if="playlist._embedded">
                                <picture>
                                  <img :src="`${playlist._embedded['wp:featuredmedia'][0].media_details.sizes['post-thumbnail'].source_url}`" :srcset="`${playlist._embedded['wp:featuredmedia'][0].media_details.sizes.full.source_url} 2x`" class="d-block m-auto" />
                                </picture>
                              </div>
                              <div class="article-duration" v-html="playlist.acf.video_duration"></div>
                            </div>
                            <div class="blog-desc">
                              <div class="description text-white" v-html="playlist.title.rendered"></div>
                            </div>
                          </div>
                        </router-link>
                      </div>
                    </div>
                    <a href="#" class="close-btn" @click="closePlaylist"></a>
                  </div>
                </transition>
              </div>
              <div class="col-8 col-md">
                <p class="m-0" v-html="post.acf.author" v-if="post.acf.author"></p>
              </div>
              <div class="col d-flex justify-content-end align-items-center">
                <social-sharing :url="post.link"
                    :title="post.title.rendered"
                    :description="post.excerpt.rendered"
                    inline-template
                    network-tag="li"
                >
                  <ul class="nav">
                    <network network="facebook">
                      <span class="icon facebook">Facebook</span>
                    </network>
                    <network network="twitter">
                      <span class="ml-4 icon twitter">Twitter</span>
                    </network>
                  </ul>
                </social-sharing>
              </div>
            </div>
          </div>
        </div> -->

        <!-- Content -->
        <div class="row justify-content-center">
          <div class="col-12 col-md-10">
            <div class="page-content" v-html="post.content.rendered"></div>
          </div>
        </div>

        <hr class="my-5">

        <div v-if="!isRelatedVideosLoaded">
          <div class="col-12 col-md-6 col-lg-4 placeholder" v-for="index in 3" :key="index">
            <div class="blog-article">
              <div class="thumbnail mb-3"></div>
              <div class="paragraph mb-4" style="width: 30%;"></div>
              <div class="paragraph mb-2" style="width: 100%;"></div>
              <div class="paragraph" style="width: 80%;"></div>
            </div>
          </div>
        </div>
        <div v-else>
          <h2 class="title text-center" v-html="$t('message.relatedvideos')"></h2>
          <div class="row my-3">
            <div class="col-12 col-md-6 col-lg-4" v-for="(video, key) in relatedVideos" :key="key">
              <router-link :to="{ name: video.type, params: { slug: video.slug } }">
                <div class="blog-article">
                  <div class="thumbnail">
                    <div class="thumbnail-media" v-lazy-container="{ selector: 'img' }" v-if="video._embedded">
                      <img :data-src="`${video._embedded['wp:featuredmedia'][0].media_details.sizes['post-thumbnail'].source_url}`" :data-srcset="`${video._embedded['wp:featuredmedia'][0].media_details.sizes.full.source_url} 2x`" class="d-block m-auto" />
                    </div>
                    <!-- /.thumbnail-media -->
                    <div class="article-duration" v-html="video.acf.video_duration"></div>
                  </div>
                  <!-- /.thumbnail -->
                  <div class="blog-desc">
                    <div class="category" v-html="$t('message.video')"></div>
                    <div class="description" v-html="video.title.rendered"></div>
                  </div>
                  <!-- /.blog-desc -->
                </div>
                <!-- /.blog-article -->
              </router-link>
            </div>
          </div>
          <!-- /.row -->
        </div>
      </div>
    </div>
    <!-- /.container pb-5 -->
  </div>
</template>

<script>
import axios from 'axios'
import dayjs from 'dayjs'
import 'dayjs/locale/th'
import JQuery from 'jquery'
const Flickity = require('flickity')
export default {
  name: 'VideoDetail',
  data () {
    return {
      title: process.env.VUE_APP_TITLE,
      api_path: process.env.VUE_APP_API_PATH,
      post: [],
      isPostLoaded: false,
      video_id: '',
      playlists: [],
      isPlaylistsLoaded: false,
      isExpandedPlaylists: false,
      relatedVideos: [],
      isRelatedVideosLoaded: false
    }
  },
  mounted () {
    this.getPost()
  },
  methods: {
    getPost () {
      const slug = this.$route.params.slug
      const lang = this.$route.params.lang
      const $vm = this
      $vm.isPostLoaded = false
      axios.get(`${this.api_path}wp-json/wp/v2/video/`, {
        params: {
          _embed: true,
          slug,
          lang
        }
      })
        .then(res => {
          if (res.data) {
            $vm.post = res.data[0]
            document.title = `${$vm.post.title.rendered} - ${$vm.title}`
            $vm.video_id = $vm.getUrlParameter($vm.post.acf.video_url, 'v')

            // All loaded
            $vm.isPostLoaded = true
            const $ = JQuery
            setTimeout(() => {
              if ($('.has-carousel')) {
                $('.has-carousel').each(function (i) {
                  var options = JSON.parse($(this).attr('data-flickity'))
                  const carousel = new Flickity($('.has-carousel')[i], options)
                  if (carousel) {}
                })
              }
            }, 100)
            $vm.getRelatedVideos()
          }
        })
    },
    getRelatedVideos () {
      const lang = this.$route.params.lang
      const $vm = this
      $vm.isRelatedVideosLoaded = false
      axios.get(`${this.api_path}wp-json/wp/v2/video/`, {
        params: {
          _embed: true,
          lang,
          per_page: 3,
          exclude: $vm.post.id
        }
      })
        .then(res => {
          $vm.relatedVideos = res.data
          $vm.isRelatedVideosLoaded = true
        })
    },
    getUrlParameter (url, name) {
      name = name.replace(/[\]/, '\\[').replace(/[\]]/, '\\]')
      const regex = new RegExp('[\\?&]' + name + '=([^&#]*)')
      const results = regex.exec(url)
      return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '))
    },
    getPlaylists (e) {
      e.preventDefault()
      const lang = this.$route.params.lang
      const vm = this
      const playlist = vm.post._embedded['wp:term'][0][0].id
      vm.isPlaylistsLoaded = false
      vm.isExpandedPlaylists = !vm.isExpandedPlaylists
      axios.get(`${this.api_path}wp-json/wp/v2/video`, {
        params: {
          playlist,
          _embed: true,
          lang
        }
      })
        .then(res => {
          if (res.data) {
            vm.playlists = res.data
            vm.isPlaylistsLoaded = true
          }
        })
    },
    closePlaylist (e) {
      e.preventDefault()
      this.isExpandedPlaylists = false
    },
    dateFormat (date, format = 'D MMMM YYYY') {
      const lang = this.$route.params.lang
      return dayjs(date).locale(lang).format(format)
    }
  },
  watch: {
    '$route' () {
      this.getPost()
    }
  }
}
</script>
